/**
 * Constants used for authentication in the Kanopi system
 *
 * Contains enum values for cookie names and authentication configuration
 */
export const enum KANOPI_AUTHENTICATOR {
  JWT_COOKIE_NAME = "kanopi_session_jwt",
  SESSION_COOKIE_NAME = "kanopi_session",
}
